import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection, SectionType, ItemSection } from '../itemSection';
import { Product } from '@/store/modules/product';
import store from '@/store';
import { ElementType } from '../element';
import { chestFurnitureLegs } from '../legs/chestFurnitureLegs';

export class ChestFurnitureSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [
        new ItemSection(SectionType.BODY_COLOR, 'Kolor korpusu', []),
        new ItemSection(SectionType.FRONT_COLOR, 'Kolor frontów', []),
        new ItemSection(SectionType.SHELF_COLOR, 'Kolor półek', []),
        new ItemSection(SectionType.WALL_COLOR, 'kolor przegródek', []),
        new ItemSection(SectionType.LEGS, 'nóżki', []),
        new ItemSection(SectionType.HANDLES, 'Klamki', []),
    ];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        this.applyLanguage();
        const furnitureShaders = store.getters.shaders.furniture;
        this.updateShaderSection(SectionType.BODY_COLOR, ElementType.BODY, furnitureShaders);
        this.updateFrontsSection(furnitureShaders);
        this.updateShaderSection(SectionType.SHELF_COLOR, ElementType.INSIDE, furnitureShaders);
        this.updateShaderSection(SectionType.WALL_COLOR, ElementType.WALL, furnitureShaders);
        this.updateLegsSection(product, chestFurnitureLegs);
        this.updateHandlesSection();
        if (
            product.depth <= 255 ||
            product.isLevelRaiser ||
            product.isShelf
        ) {
            this.hideLegsSection();
        }
        if (!product.canHaveWalls) {
            this.hide(SectionType.WALL_COLOR);
        }
        return this.sections.filter((x) => x.visible);
    }

    protected applyLanguage() {
        this.getSectionByType(SectionType.BODY_COLOR).text = this.scenePreview.$t('bodyColor');
        this.getSectionByType(SectionType.FRONT_COLOR).text = this.scenePreview.$t('frontColor');
        this.getSectionByType(SectionType.SHELF_COLOR).text = this.scenePreview.$t('shelfColor');
        this.getSectionByType(SectionType.WALL_COLOR).text = this.scenePreview.$t('wallColor');
        this.getSectionByType(SectionType.LEGS).text = this.scenePreview.$t('legs');
        this.getSectionByType(SectionType.HANDLES).text = this.scenePreview.$t('handles');
    }
}
